import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TruckGroupGateCondition } from '../../../truck-group.model';

@Component({
  selector: 'app-truck-group-condition',
  templateUrl: './truck-group-condition.component.html',
  styleUrls: ['./truck-group-condition.component.scss']
})
export class TruckGroupConditionComponent implements OnInit {

  @Input() condition: TruckGroupGateCondition;

  @Output() removeCondition = new EventEmitter<TruckGroupGateCondition>();

  constructor() { }

  ngOnInit() {
  }

  onDelete() {
    this.removeCondition.emit(this.condition);
  }
}
